jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').size() !== 0) return false;
	
	setupColumns();
	setupFancyFocus();
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).size();
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest("li").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest("li").removeClass('focus');
		}
		
	});
}
